<template>
  <div class="container">
    <div v-if="loading" class="loading-top">
      <van-loading type="spinner" color="#1989fa" size="24px">{{ $i18n('loading', '加载中...') }}</van-loading>
    </div>
    <div class="chatContainer" ref="scrollDiv" v-scroll="handleScroll">
      <div ref="chatScroll" class="chatScrollWrap">
        <template v-for="(chatItem, index) in chatShowList">
          <ChatMsg v-if="chatItem.type===0" :chatItem="chatItem" :key="index"/>
          <ChatTip v-else-if="chatItem.type===1" :chatItem="chatItem" :key="index"/>
          <ChatWish v-else-if="chatItem.type===2" :chatItem="chatItem" :key="index"/>
          <ChatSign v-else-if="chatItem.type===4" :chatItem="chatItem" :key="index"/>
          <ChatRedPacket v-else-if="chatItem.type===5" :chatItem="chatItem" :key="index"/>
          <ChatCard v-else-if="chatItem.type===6" @edit-card="onEditCard" @set-email="onRefresh" :chatItem="chatItem"
                    :key="index"/>
          <ChatRes v-else-if="chatItem.type===9" :chatItem="chatItem" :key="index"/>
          <ChatNotice v-else-if="chatItem.type===10" :chatItem="chatItem" :key="index"/>
          <ChatPic v-else-if="chatItem.type===7" :picList="chatShowList.filter(item => item.type === 7)"
                   :chatItem="chatItem" :key="index"/>
          <span class="timeTip" v-if="chatItem.createTime">{{ formatTime(chatItem.createTime) }}</span>
        </template>
      </div>
    </div>
    <div class="newMsgTipWrap" v-if="showNewMsgTip" @click="onRefreshChat">
      <img src="@/assets/icons/icon_go_down.png"/>{{ unreadCount }}{{ $i18n('newMessages', '条新消息') }}
    </div>
    <div v-show="showInputTip" class="chatInputTip">{{ tipMsg }}</div>
    <div class="chatInputWrap" v-if="showInput" ref="chatInputRef">
      <div class="inputWrap">
        <van-field
            ref="inputRef"
            v-model="chatContext"
            rows="1"
            autosize
            class="inputTxt"
            type="textarea"
            :placeholder="$i18n('enterContent', '请输入内容')"
            @input="handleInput"
        />
        <GiftFloat/>
        <button class="sendBt" v-if="showSendBt" ref="sendBt" @click="inputChat">{{ $i18n('send', '发送') }}</button>
        <!-- 婚礼风格「送祝福」按钮：没文字时显示，有文字时让位给发送按钮 -->
        <button class="wishBt" v-else ref="addBt" :class="{ sending: wishSending }" @click="sendWish">
          <span class="wishHeart">❤</span>
          <span class="wishText">{{ $i18n('sendWish', '送祝福') }}</span>
          <span class="wishShine"></span>
        </button>
      </div>
    </div>
    <van-popup
        v-model="showOpt"
        position="bottom"
        round
        :style="{ width: '100%' }">
      <van-grid direction="horizontal" :column-num="2">
        <van-grid-item v-if="showBirthdayGiftBt" :text="$i18n('sendBusinessCard', '送蛋糕')" icon="https://qiniu.dljok.com/dir/7309639e01bd4b32a24b746af4b27196.png"
                       @click="openGoods('fcbb6617586e9cc75d98388a0968643d')"/>
        <van-grid-item :text="$i18n('sendBusinessCard', '送祝福')" icon="https://qiniu.dljok.com/static/icon/h5/icon_wish.png"
                       @click="sendWish"/>
        <van-grid-item v-if="showSendCardBt" :text="$i18n('sendBusinessCard', '发名片')" icon="https://qiniu.dljok.com/static/icon/h5/icon_card.png" @click="openCard"/>
        <van-grid-item :text="$i18n('sendPhoto', '发照片')"
                       icon="https://qiniu.dljok.com/static/icon/h5/icon_photo.png"
                       @click="openPhotoPicker"/>
        <van-grid-item :text="$i18n('sendGift', '发礼物')" icon="https://qiniu.dljok.com/static/icon/h5/icon_gift.png" @click="openGift"/>
        <van-grid-item v-if="showSendRedPacketBt" :text="$i18n('sendRedPacket', '发红包')"
                       icon="https://qiniu.dljok.com/static/icon/h5/icon_redpacket.png"
                       @click="openSendRedPacket"/>
        <van-grid-item v-if="showSendResourceBt" icon="https://qiniu.dljok.com/static/wxapp/icon/icon_resource.png" text="发资源" @click="openSendResource"/>
        <van-grid-item v-if="showMakeFriendBt" icon="https://qiniu.dljok.com/static/icon/h5/icon_addf.png" text="发送交友（100金币）" />
      </van-grid>
    </van-popup>
    <van-popup v-model="showInputCard"
               position="bottom"
               v-if="userForm"
               round
               :style="{ width: '100%', height: '56%' }">
      <van-form @submit="onSubmit">
        <van-cell-group inset>
          <!-- 扫描名片按钮 -->
          <van-cell center>
            <template #title>
              <span class="custom-title">{{ $i18n('scanCard', '扫描名片') }}</span>
            </template>
            <template #right-icon>
              <van-button
                  icon="scan"
                  type="primary"
                  size="small"
                  @click="triggerFileInput"
              >{{ $i18n('scan', '扫描') }}
              </van-button>
              <input
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleFileUpload"
              />
            </template>
          </van-cell>
          <van-field
              v-model="userForm.realName"
              :label="$i18n('yourName', '您的姓名')"
              :placeholder="$i18n('enterYourName', '填写您的姓名')"
              :rules="[{ required: true, message: $i18n('enterYourName', '填写您的姓名') }]"
          />
          <van-field
              v-model="userForm.company"
              :label="$i18n('companyName', '公司名称')"
              :placeholder="$i18n('enterCompanyName', '填写公司名称')"
              :rules="[{ required: true, message: $i18n('enterCompanyName', '请填写公司名称') }]"
          />
          <van-field
              v-model="userForm.position"
              :label="$i18n('yourPosition', '您的职位')"
              :placeholder="$i18n('enterYourPosition', '填写您的职位')"
              :rules="[{ required: true, message: $i18n('enterYourPosition', '填写您的职位') }]"
          />
          <van-field
              v-model="userForm.intro"
              rows="2"
              autosize
              :label="$i18n('businessIntro', '业务介绍')"
              type="textarea"
              maxlength="50"
              :placeholder="$i18n('yourIntro', '您的介绍（业务介绍/交友介绍）')"
              show-word-limit
          />
        </van-cell-group>
        <div style="margin: 16px;">
          <van-button round block type="primary" native-type="submit">
            {{ $i18n('submit', '提交') }}
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <van-popup v-model="showAddResource"
               position="bottom"
               round
               :style="{ width: '100%', height: '46%' }">
      <van-nav-bar
          :title="$i18n('createResourcePackage', '创建资源包')"
          :left-text="$i18n('cancel', '取消')"
          :right-text="$i18n('confirm', '确认')"
          @click-left="showAddResource = false"
          @click-right="onSubmitResource"
      />
      <van-form @submit="onSubmitResource">
        <van-cell-group inset>
          <van-field
              v-model="resourceForm.name"
              :label="$i18n('resourceName', '资源名称')"
              :placeholder="$i18n('enterResourceName', '填写资源名称')"
          />
          <van-field
              v-model="resourceForm.price"
              :label="$i18n('goldCoin', '金币')"
              type="digit"
              :placeholder="$i18n('setGoldForRedPacket', '设置金币可获得现金红包')"
          />
          <van-field
              v-model="resourceForm.intro"
              rows="2"
              autosize
              :label="$i18n('remark', '备注')"
              type="textarea"
              maxlength="50"
              :placeholder="$i18n('resourceDownloadDesc', '资源下载描述')"
              show-word-limit
          />
        </van-cell-group>
      </van-form>
    </van-popup>
    <van-popup v-model="showPicker"
               position="bottom"
               round
               :style="{ height: '62%',backgroundColor:'#f2f2f2' }"
    >
      <!-- 标题栏 -->
      <van-nav-bar
          :title="$i18n('sendPhoto', '发照片')"
          :left-text="$i18n('cancel', '取消')"
          :right-text="$i18n('confirm', '确认')"
          @click-left="showPicker = false"
          @click-right="handleSendPhoto"
      />

      <!-- 照片选择器组件 -->
      <photo-picker
          ref="photoPicker"
          :max-count="24"
          @select-success="onSelectSuccess"
          @upload-success="onUploadSuccess"
      />
    </van-popup>
    <van-popup v-model="showSendResource"
               position="bottom"
               round
               :style="{ height: '62%',backgroundColor:'#f2f2f2' }"
    >
      <!-- 标题栏 -->
      <van-nav-bar
          :title="$i18n('sendResource', '发资源')"
          :left-text="$i18n('cancel', '取消')"
          :right-text="$i18n('confirm', '确认')"
          @click-left="showSendResource = false"
          @click-right="handleSendResource"
      />
      <!-- 资源选择器组件 -->
      <resource-picker
          @onOpenAddRes="onOpenAddRes"
          @select-res-success="onSelectResSuccess"
      />
    </van-popup>
    <van-popup v-model="showSendPacket"
               position="bottom"
               round
               :style="{ height: '46%' }">
      <van-form @submit="onSendRedPacket">
        <van-field
            v-model="redPacketForm.number"
            :label="$i18n('redPacketCount', '红包个数')"
            type="digit"
            :rules="[{ required: true, message: $i18n('enterRedPacketCount', '请填写红包个数') }]"
        />
        <van-field
            v-model="redPacketForm.quantity"
            type="number"
            :label="$i18n('totalAmount', '总金额')"
            placeholder="0.00"
            :rules="[{ required: true, message: $i18n('enterAmount', '请填写金额') }]"
        />
        <van-field v-model="redPacketForm.wish"
                   :placeholder="$i18n('congratulationsProsperity', '恭喜发财，大吉大利')" :label="$i18n('blessings', '祝福语')"/>
        <div class="submitWrap">
          <span class="tip">{{ $i18n('availableRedPacket', '您当前可用红包') }}¥{{ userInfo.brokeragePrice }}</span>
          <van-button round block type="primary" native-type="submit">
            {{ $i18n('submit', '提交') }}
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <van-popup v-model="showUploadResource"
               position="bottom"
               round
               :style="{ height: '46%' }">
      <van-nav-bar
          :title="$i18n('uploadResource', '上传资源')"
          :left-text="$i18n('back', '返回')"
          @click-left="openSendResource"
          left-arrow
      />
      <UploadResource
          :max-count="100"
          :max-size="100"
          :package-id="packageId"
          ref="uploadResRef"
      />
    </van-popup>
    <van-overlay :show="showGetRedPacket" @click="closeGetRedPacket">
      <div class="wrapper">
        <div class="block">
          <span class="title">{{ $i18n('cashRedPacketAmount', '现金红包金额') }}</span>
          <span class="money">¥{{ redPacketRecordObj.quantity }}</span>
          <van-button round type="primary" @click="onGetRedPacket">{{ $i18n('clickToClaim', '点击领取') }}</van-button>
        </div>
      </div>
    </van-overlay>
    <EmailInputDialog
        :visible="showOpenResDialog"
        @confirm="onEmailConfirm"
        @cancel="onEmailCancel"
    />
    <NoticePopup :visible.sync="showAddNotice"/>
    <DynamicPopup @content-selected="onContentSelected"/>
    <WechatPaymentPopup
        ref="paymentPopup"
        @confirmSuccess="handlePaymentSuccess"
        @confirmFail="handlePaymentFail"
    />
    <MemorialAltar ref="memorialRef"/>
    <GoodsPopup ref="goodsPopup" :show.sync="showProduct" @added="onCartAdded" />
  </div>
</template>

<script>
import {formatDistanceToNow} from 'date-fns';
import {zhCN} from 'date-fns/locale';
import MemorialAltar from "@views/home/model/memorial/MemorialAltar";
import EmailInputDialog from "@/views/home/model/popup/EmailInputDialog";
import UploadResource from '@/views/home/model/popup/UploadResource.vue';
import NoticePopup from '@/views/home/model/popup/NoticePopup.vue';
import GoodsPopup from "@/views/home/model/popup/GoodsPopup";
import PhotoPicker from '@/views/home/model/popup/PhotoPicker.vue';
import WechatPaymentPopup from '@/views/home/model/popup/WechatPaymentPopup';
import ResourcePicker from '@/views/home/model/popup/ResourcePicker.vue';
import {Toast, Popup, NavBar, Button, Dialog, CellGroup, Cell} from "vant";
import {mapGetters, mapState} from "vuex";
import {_code, defaultAvatar} from "@/utils/constant";
import wx from "weixin-js-sdk";
import store from "@/store";
import ChatMsg from "@views/home/model/chatItem/ChatMsg";
import ChatTip from "@views/home/model/chatItem/ChatTip";
import ChatCard from "@views/home/model/chatItem/ChatCard";
import ChatPic from "@views/home/model/chatItem/ChatPic";
import ChatRedPacket from "@views/home/model/chatItem/ChatRedPacket";
import ChatRes from "@views/home/model/chatItem/ChatRes";
import ChatNotice from "@views/home/model/chatItem/ChatNotice";
import DynamicPopup from "./popup/DynamicPopup";
import ChatWish from "@views/home/model/chatItem/ChatWish";
import ChatSign from "@views/home/model/chatItem/ChatSign";
import i18nMixin from "@/libs/i18nMixin";
import RechargePopup from "@views/home/model/popup/RechargePopup.vue";
import GiftFloat from "@components/GiftFloat.vue";

export default {
  name: "GiftPop",
  mixins: [i18nMixin],
  data: function () {
    return {
      showProduct: false,
      showNewMsgTip: false,
      unreadCount: 0, // 未读消息数量
      defaultRedPacketWish: this.$i18n('congratulationsProsperity', '恭喜发财，大吉大利'),
      isUserAtBottom: true, // 标记用户是否处于消息底部
      tempChatList: [], // 临时存储预加载的数据
      isPreloading: false, // 标记是否正在预加载（避免重复请求）
      tipMsg: '',
      wishSending: false, // 送祝福发送中（防连点 + 按钮呼吸态）
      resourceForm: {},
      userForm: {},
      redPacketForm: {
        number: 6,
        wish: this.defaultRedPacketWish,
        quantity: 9.9,
      },
      packageId: null,
      showAddNotice: false,
      showOpenResDialog: false,
      showUploadResource: false,
      showAddResource: false,
      redPacketRecordObj: {},
      showGetRedPacket: false,
      showSendResource: false,
      showSendPacket: false,
      showPicker: false,
      selectedResources: [], // 已选择的资源列表
      selectedPhotos: [], // 已选择的照片列表
      showInputCard: false,
      showOpt: false,
      showInput: true,
      showSendBt: false,
      showInputTip: false,
      chatContext: "",
      defaultAvatar: defaultAvatar,
      pageNo: 1,
      size: 20,
      textareaHeight: 0,
      loadend: false,
      chatList: [],
      chatShowList: [],
      position: {scrollTop: 0, scrollLeft: 0},
      loading: false,
      isLoadingMore: false
    };
  },
  components: {
    GiftFloat,
    RechargePopup,
    GoodsPopup,
    MemorialAltar,
    WechatPaymentPopup,
    DynamicPopup,
    ChatSign,
    ChatWish,
    ChatMsg,
    ChatTip,
    ChatCard,
    ChatPic,
    ChatRedPacket,
    ChatRes,
    ChatNotice,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    PhotoPicker,
    ResourcePicker,
    UploadResource,
    EmailInputDialog,
    NoticePopup
  },
  created() {
    this.onRefreshChat();
  },
  // updated() {
  //   this.scrollToBottom();
  // },
  mounted() {
    this.$Bus.$on("appendChatMsg", (chatMsg) => {
      this.appendChatMsg(chatMsg);
    });
    this.$Bus.$on("refreshCoin", () => {
      this.onRefresh();
    });
    this.$Bus.$on("refreshMsg", () => {
      this.onRefreshChat();
    })
    this.$Bus.$on("triggerOpenRes", () => {
      this.showOpenResDialog = true
    })
    this.$Bus.$on("triggerOpenUpRes", (val) => {
      this.packageId = val;
      this.showSendResource = false;
      this.showUploadResource = true;
      this.$nextTick(() => {
        if (this.$refs.uploadResRef) {
          this.$refs.uploadResRef.loadResList(val);
        }
      });
    })
    // 监听礼物触发事件
    this.$Bus.$on("triggerGift", (val) => {
      if (val) {
        this.showInput = false
      } else {
        this.showInput = true
      }
    })
    this.handleSocketMessage = this.handleSocketMessage.bind(this);
    this.$store.commit('ADD_MESSAGE_LISTENER', this.handleSocketMessage);
  },
  beforeDestroy() {
    this.$store.commit('REMOVE_MESSAGE_LISTENER', this.handleSocketMessage);
    this.$Bus.$off("refreshCoin");
    this.$Bus.$off("refreshMsg");
    this.$Bus.$off("triggerOpenRes");
    this.$Bus.$off("triggerOpenUpRes");
    this.$Bus.$off("triggerGift");
    this.$Bus.$off("appendChatMsg");
  },
  computed: {
    ...mapGetters(["live", "userInfo","appConfig"]),
    showBirthdayGiftBt() {
      return ['birthday'].includes(this.live.liveTypeCode);
    },
    showSendCardBt() {
      return ['chat_group','meeting_sales','business_activity','company_meeting'].includes(this.live.liveTypeCode);
    },
    showSendResourceBt() {
      return ['chat_group','meeting_sales','business_activity','company_meeting'].includes(this.live.liveTypeCode);
    },
    showSendRedPacketBt() {
      return ['chat_group','birthday','meeting_sales','wedding','business_activity','company_meeting'].includes(this.live.liveTypeCode);
    },
    showMakeFriendBt() {
      return false;
      // return ['chat_group','wedding','business_activity','company_meeting'].includes(this.live.liveTypeCode);
    },
    showPubAlarm() {
      const uid = this.live.uid;
      const id = this.userInfo.id;
      return uid === id;
    }
  },
  methods: {
    openGoods(productId) {
      // 一行代码弹出
      this.$refs.goodsPopup.open(productId);
    },
    onCartAdded(){
      console.log('购买回调');
    },
    handleSocketMessage(msg) {
      // console.log('jie到消息-------',msg);
      switch (msg.msgType) {
        case _code.SEND_NOTICE: {
          // 发送通知
          let param = {
            type: 10,
            chatContext: msg.data,
            liveId: this.live.id,
            nickname: msg.nickname,
            avatar: msg.avatar,
          };
          if (this.live.id === msg.liveId) {
            this.chatShowList.push(param);
            // 新消息处理逻辑
            if (this.isUserAtBottom) {
              // 若用户在底部，自动滚动到底部，不计数
              this.scrollToBottom();
              this.unreadCount = 0;
              this.showNewMsgTip = false;
            } else {
              // 若用户不在底部，累计未读数量并显示提示
              this.unreadCount++;
              this.showNewMsgTip = true;
            }
          }
          break;
        }
        case _code.SEND_CARD: {
          // 发送名片
          let param = {
            type: 6,
            chatContext: msg.data,
            liveId: this.live.id,
            nickname: msg.nickname,
            avatar: msg.avatar,
          };
          if (this.live.id === msg.liveId) {
            this.chatShowList.push(param);
            // 新消息处理逻辑
            if (this.isUserAtBottom) {
              // 若用户在底部，自动滚动到底部，不计数
              this.scrollToBottom();
              this.unreadCount = 0;
              this.showNewMsgTip = false;
            } else {
              // 若用户不在底部，累计未读数量并显示提示
              this.unreadCount++;
              this.showNewMsgTip = true;
            }
          }
          break;
        }
        case _code.SEND_MSG:{
          // 发送消息
          let jsonData = JSON.parse(msg.data);
          let param = {
            type: 0,
            chatContext: jsonData.chatContext,
            liveId: this.live.id,
            nickname: msg.nickname,
            avatar: msg.avatar,
          };
          if (this.live.id === msg.liveId) {
            this.chatShowList.push(param);
            // 新消息处理逻辑
            if (this.isUserAtBottom) {
              // 若用户在底部，自动滚动到底部，不计数
              this.scrollToBottom();
              this.unreadCount = 0;
              this.showNewMsgTip = false;
            } else {
              // 若用户不在底部，累计未读数量并显示提示
              this.unreadCount++;
              this.showNewMsgTip = true;
            }
          }
          break;
        }
        case _code.SEND_GIFT:{
          // 发礼物
          let jsonData = JSON.parse(msg.data);
          let param = {
            type: 1,
            chatContext: this.$i18n('sentGift', '送来了礼物,') + jsonData.giftName,
            liveId: this.live.id,
            nickname: msg.nickname,
            avatar: msg.avatar,
          };
          if (this.live.id === msg.liveId) {
            this.chatShowList.push(param);
            // 新消息处理逻辑
            if (this.isUserAtBottom) {
              // 若用户在底部，自动滚动到底部，不计数
              this.scrollToBottom();
              this.unreadCount = 0;
              this.showNewMsgTip = false;
            } else {
              // 若用户不在底部，累计未读数量并显示提示
              this.unreadCount++;
              this.showNewMsgTip = true;
            }
          }
          break;
        }
        case _code.SIGN:{
          // 签到
          let param = {
            type: 4,
            chatContext: msg.data,
            liveId: this.live.id,
            nickname: msg.nickname,
            avatar: msg.avatar,
          };
          if (this.live.id === msg.liveId) {
            this.chatShowList.push(param);
            // 新消息处理逻辑
            if (this.isUserAtBottom) {
              // 若用户在底部，自动滚动到底部，不计数
              this.scrollToBottom();
              this.unreadCount = 0;
              this.showNewMsgTip = false;
            } else {
              // 若用户不在底部，累计未读数量并显示提示
              this.unreadCount++;
              this.showNewMsgTip = true;
            }
          }
          break;
        }
        case _code.CONFIRM_RED_PACKET:{
          // 红包确认
          if (this.live.id === msg.liveId) {
            // 新消息处理逻辑
            if (this.isUserAtBottom) {
              this.onRefreshChat();
              this.unreadCount = 0;
              this.showNewMsgTip = false;
            } else {
              // 若用户不在底部，累计未读数量并显示提示
              this.unreadCount++;
              this.showNewMsgTip = true;
            }
          }
          break;
        }
        case _code.SEND_RED_PACKET:{
          // 发送红包
          if (this.live.id === msg.liveId) {
            // 新消息处理逻辑
            if (this.isUserAtBottom) {
              this.onRefreshChat();
              this.unreadCount = 0;
              this.showNewMsgTip = false;
            } else {
              // 若用户不在底部，累计未读数量并显示提示
              this.unreadCount++;
              this.showNewMsgTip = true;
            }
          }
          break;
        }
        case _code.SEND_PIC:{
          // 发照片
          let param = {
            type: 7,
            chatContext: msg.data,
            liveId: this.live.id,
            nickname: msg.nickname,
            avatar: msg.avatar,
          };
          if (this.live.id === msg.liveId) {
            this.chatShowList.push(param);
            // 新消息处理逻辑
            if (this.isUserAtBottom) {
              // 若用户在底部，自动滚动到底部，不计数
              this.scrollToBottom();
              this.unreadCount = 0;
              this.showNewMsgTip = false;
            } else {
              // 若用户不在底部，累计未读数量并显示提示
              this.unreadCount++;
              this.showNewMsgTip = true;
            }
          }
          break;
        }
      }
    },
    // 打开收款弹出框
    // openPaymentPopup() {
    //   this.$refs.paymentPopup.openPopup({
    //     amount: 99.99,  // 收款金额
    //     orderId: 'ORDER_12345678',  // 订单ID
    //     description: this.$i18n('paymentPending', '您有一笔直播打赏待确认收款')  // 附加说明
    //   });
    // },

    // 处理收款成功
    handlePaymentSuccess(res) {
      console.log('收款确认成功', res);
      // 处理成功逻辑，如显示成功提示、更新订单状态等
    },

    // 处理收款失败
    handlePaymentFail(err) {
      console.log('收款确认失败', err);
      // 处理失败逻辑，如显示错误提示等
    },
    formatTime(date) {
      // 1. 校验入参是否存在
      if (!date) {
        return ''; // 无效值直接返回空
      }

      // 2. 处理数字字符串（核心优化点）
      let numericDate;
      if (typeof date === 'string') {
        // 判断是否为纯数字字符串（如 "1628284800000"）
        if (/^\d+$/.test(date)) {
          // console.log('date------',date);
          numericDate = Number(date); // 转换为数字
        } else {
          // 非数字字符串，尝试直接解析为日期（如 "2023-08-07"）
          numericDate = date;
        }
      } else if (typeof date === 'number') {
        // 本身是数字（时间戳）
        numericDate = date;
      } else if (date instanceof Date) {
        // 已为 Date 对象
        numericDate = date;
      } else {
        // 其他无效类型
        return '';
      }

      // 3. 转换为 Date 对象并校验有效性
      const targetDate = new Date(numericDate);
      if (isNaN(targetDate.getTime())) {
        // 无效时间（如解析失败）
        return '';
      }

      // 4. 格式化有效时间
      return formatDistanceToNow(targetDate, {
        addSuffix: true,
        locale: zhCN
      });
    },
    // 触发文件选择
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    // 处理文件上传
    handleFileUpload(event) {
      this.showInputCard = true;
      const file = event.target.files[0];
      if (!file) return;

      // 1. 转换为 Base64
      this.convertToBase64(file)
          .then(base64Data => {
            // 2. 上传到后台
            return this.uploadBusinessCard(base64Data);
          })
          .then(response => {
            // 3. 解析返回的数据并填充表单
            if (response.data) {
              this.fillFormWithScannedData(response.data);
            }
          })
          .catch(error => {
            console.error('扫描名片失败:', error);
            this.$toast.fail(this.$i18n('scanCardFailed', '扫描名片失败，请重试'));
          });
    },
    // 上传 Base64 数据到后台
    uploadBusinessCard(base64Data) {
      return this.$http.post('/card/scanCard', {imageBase64: base64Data});
    },
    // 填充表单数据
    fillFormWithScannedData(data) {
      if (data.name) this.userForm.realName = data.name;
      if (data.company) this.userForm.company = data.company;
      if (data.position) this.userForm.position = data.position;
      this.$toast.success(this.$i18n('cardScanSuccess', '名片扫描成功！'));
    },
    // 将图片转换为 Base64
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    onContentSelected(msg) {
      console.log('------' + JSON.stringify(msg));
      const type = msg.type;
      switch (type) {
        case 'card':
          this.openCard();
          break;
        case 'redPacket':
          this.openSendRedPacket();
          break;
        case 'resource':
          this.openSendResource();
          break;
        case 'photo':
          this.openPhotoPicker();
          break;
        case 'wish':
          this.sendWish();
          break;
      }
    },
    onEditCard() {
      store.dispatch("USERINFO").then((res) => {
        this.userForm = {
          realName: res.realName,
          company: res.company,
          position: res.position,
          intro: res.intro
        };
        this.showInputCard = true;
      })
    },
    onRefresh() {
      this.$store.dispatch('USERINFO').then(() => {
        console.log('更新用户信息')
      })
    },
    onEmailConfirm() {
      this.$store.dispatch('USERINFO').then(() => {
        this.showOpenResDialog = false;
      })
    },
    onEmailCancel() {
      this.showOpenResDialog = false;
    },
    onOpenAddRes() {
      this.showSendResource = false;
      this.showAddResource = true;
      this.resourceForm = {};
    },
    onSubmitResource() {
      this.$http.post('/api/dlrUserResourcePackage/insert', this.resourceForm).then(() => {
        this.$toast.success(this.$i18n('createResourceSuccess', '创建资源包成功！'));
        this.showSendResource = true;
        this.showAddResource = false;
        this.$Bus.$emit("triggerRefreshResData");
      })
    },
    closeGetRedPacket() {
      this.showGetRedPacket = false;
    },
    onGetRedPacket() {
      this.$http.get(`/chat/fetchRedPacket?redPacketRecordId=${this.redPacketRecordObj.redPacketRecordId}
      &chatId=${this.redPacketRecordObj.chatId}`).then(() => {
        this.showGetRedPacket = false;
        this.$toast(this.$i18n('claimSuccessWatchWeChat', '收取成功，稍后请关注微信红包！'));
        this.$Bus.$emit("triggerHasGet", {chatId: this.redPacketRecordObj.chatId, hasGet: true});
      }).catch(err => {
        this.$toast(err.message);
      })
    },
    onSendRedPacket() {
      // console.log('提交红包------');
      if (this.redPacketForm.number < 1) {
        this.$toast(this.$i18n('redPacketCountMin', '红包数量不能少于1！'));
        return;
      }
      if (this.redPacketForm.quantity < 0.3) {
        this.$toast(this.$i18n('minAmount0.3', '最小金额不能小于¥0.3！'));
        return;
      }
      const total = this.redPacketForm.quantity * this.redPacketForm.number;
      if (total < 0.3) {
        this.$toast(this.$i18n('avgMinAmount0.3', '红包平均最小金额不能小于¥0.3！'));
        return;
      }
      this.redPacketForm.liveId = this.live.id;
      this.$http.post('/chat/sendRedPacket', this.redPacketForm).then(res => {
        if (res.data.isSend) {
          this.$toast.success(this.$i18n('sendSuccess', '发送成功！'));
          this.scrollToBottom();
        } else {
          wx.miniProgram.navigateTo({
            url: `/pages/wxpay/wxpay?uni=${res.data.orderId}&payType=send_red_packet`,
          });
        }
      }).catch(() => {
        this.$toast.fail(this.$i18n('sendFailed', '发送失败'));
      }).finally(() => {
        this.showSendPacket = false;
      });
    },
    onSelectSuccess(data) {
      this.selectedPhotos = data;
    },
    onSelectResSuccess(data) {
      this.selectedResources = data.map(item => item.id);
    },
    // 上传成功回调
    onUploadSuccess(data) {
      this.$http.post('/api/dlrUserMaterial/insert', {
        type: 1,
        resUrl: data
      }).then(() => {
        // this.selectedPhotos.push(data);
        this.$toast.success(this.$i18n('uploadToLibrary', '上传到素材库！'));
      })
    },
    // 发送资源
    handleSendResource() {
      if (this.selectedResources.length === 0) {
        this.$toast(this.$i18n('selectAtLeastOneResource', '请至少选择一个资源'));
        return;
      }
      this.$http.post('/chat/sendResource', {
        packageList: this.selectedResources,
        liveId: this.live.id
      }).then(() => {
        this.$toast.success(this.$i18n('resourceSendSuccess', '资源发送成功'));
        this.showSendResource = false;
        this.scrollToBottom();
      }).catch(() => {
        this.$toast.fail(this.$i18n('resourceSendFailed', '资源发送失败'));
      });
    },
    // 发送照片
    handleSendPhoto() {
      if (this.selectedPhotos.length === 0) {
        this.$toast(this.$i18n('selectAtLeastOnePhoto', '请至少选择一张照片'));
        return;
      }
      // 调用发送接口（示例）
      this.$http.post('/chat/sendPhoto', {
        photos: this.selectedPhotos,
        liveId: this.live.id
      }).then(() => {
        this.$toast.success(this.$i18n('sendSuccess', '发送成功'));
        this.showPicker = false;
        this.scrollToBottom();
      }).catch(() => {
        this.$toast.fail(this.$i18n('sendFailed', '发送失败'));
      });
    },
    onSubmit() {
      this.$http.post('/user/setCard', this.userForm).then(res => {
        this.$toast.success(this.$i18n('sendSuccess', '发送成功！'));
        this.showInputCard = false;
        this.scrollToBottom();
      })
    },
    /**
     * 通用：把单条消息追加到聊天列表
     * 供本地发送成功回调、$Bus 跨组件回调复用
     */
    appendChatMsg(chatMsg) {
      if (!chatMsg || !chatMsg.liveId) return;
      // 防串场：只追加当前直播间的消息
      if (this.live.id !== chatMsg.liveId) return;
      // 幂等：如果消息已存在（如服务端同时推送了 WebSocket），跳过
      if (this.chatShowList.some(item => item.id === chatMsg.id)) return;

      this.chatShowList.push(chatMsg);

      if (this.isUserAtBottom) {
        this.scrollToBottom();
        this.unreadCount = 0;
        this.showNewMsgTip = false;
      } else {
        this.unreadCount++;
        this.showNewMsgTip = true;
      }
    },
    /* ═══ 送祝福：防连点 + 成功后爱心迸发 ═══ */
    sendWish() {
      if (this.wishSending) return; // 防连点
      this.wishSending = true;
      let param = {
        liveId: this.live.id,
      };
      this.$http
          .post("/wish/sendWish", param)
          .then((res) => {
            if (res.data.isSend) {
              this.showOpt = false;
              this.$Bus.$emit("refreshCoin");
              this.$toast.success(this.$i18n('sendSuccess', '发送成功！'));
              this.burstHearts(); // 爱心迸发反馈
              this.appendChatMsg(res.data.chatMsg);
            } else {
              this.$toast.fail({ message: this.$i18n('insufficientCoins', '金币不足，请稍等...') });
              this.$Bus.$emit("triggerOpenRecharge");
            }
          })
          .finally(() => {
            this.wishSending = false;
          });
    },
    /** 爱心迸发：从按钮位置飘出 6 颗小爱心后消散 */
    burstHearts() {
      const btn = this.$refs.addBt;
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      const ox = rect.left + rect.width / 2;
      const oy = rect.top;
      for (let i = 0; i < 6; i++) {
        const el = document.createElement('span');
        el.className = 'wishBurstHeart';
        el.textContent = ['❤', '💕', '💖', '🧡', '💛', '💗'][i];
        el.style.left = ox + 'px';
        el.style.top = oy + 'px';
        el.style.setProperty('--dx', (Math.random() * 120 - 60) + 'px');
        el.style.setProperty('--rot', (Math.random() * 60 - 30) + 'deg');
        el.style.animationDelay = (i * 0.08) + 's';
        document.body.appendChild(el);
        setTimeout(() => el.remove(), 1600);
      }
    },
    openCard() {
      store.dispatch("USERINFO").then((res) => {
        if (res.realName && res.company && res.position) {
          let param = {
            chatContext: this.chatContext,
            liveId: this.live.id,
            nickname: this.userInfo.nickname,
            avatar: this.userInfo.avatar,
          };
          this.showInputTip = true;
          this.tipMsg = this.$i18n('cardSending', '名片发送...');
          this.$http.post('/chat/insertCard', param).then(() => {
            console.log('发送成功！')
            this.$toast.success(this.$i18n('sendSuccess', '发送成功！'));
            this.scrollToBottom();
          }).finally(() => {
            this.showOpt = false;
            this.showInputTip = false;
            this.tipMsg = "";
          })
        } else {
          this.userForm = {
            realName: res.realName,
            company: res.company,
            position: res.position,
            intro: res.intro
          };
          this.showInputCard = true;
          this.showOpt = false;
        }
      });
    },
    openGift() {
      this.$Bus.$emit("openGift");
      this.showOpt = false;
    },
    openSendResource() {
      this.showUploadResource = false;
      this.showOpt = false;
      this.showSendResource = true;
      this.$Bus.$emit("triggerRefreshResData");
    },
    openSendRedPacket() {
      this.$store.dispatch('USERINFO').then(() => {
        this.showSendPacket = true;
        this.showOpt = false;
      })
    },
    openPhotoPicker() {
      this.showPicker = true;
      this.showOpt = false;
    },
    triggerOpt() {
      if (this.showOpt) {
        this.showOpt = false;
      } else {
        this.showOpt = true;
      }
    },
    handleInput() {
      this.$nextTick(() => {
        // 正确获取 Vant 文本域的真实 DOM
        const textarea = this.$refs.inputRef.$el.querySelector('textarea');
        if (!textarea) return;
        const charCount = this.chatContext.length;
        if (charCount > 0) {
          this.showSendBt = true
        } else {
          this.showSendBt = false
        }
      })
    },
    onRefreshChat() {
      this.pageNo = 1;
      this.loadend = false;
      this.chatList = [];
      this.tempChatList = []; // 清空临时数据
      this.unreadCount = 0; // 清空未读计数
      this.showNewMsgTip = false; // 隐藏提示
      // 首次加载直接显示，不经过临时变量
      this.getInitialChatList();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const scrollDiv = this.$refs.scrollDiv;
        if (scrollDiv) {
          console.log('滚动到底部！')
          scrollDiv.scrollTop = scrollDiv.scrollHeight;
          // 添加 setTimeout 确保滚动执行
          setTimeout(() => {
            scrollDiv.scrollTop = scrollDiv.scrollHeight;
          }, 50);
        }
      });
    },
    handleScroll(e) {
      const scrollDiv = e.target;
      const {scrollTop, scrollHeight, clientHeight} = scrollDiv;
      const totalScrollableHeight = scrollHeight - clientHeight; // 可滚动的总高度

      // 关键：判断用户是否处于底部区域（距离底部小于一屏高度）
      // 若滚动位置距离底部超过 clientHeight（一屏高度），则认为超过一屏
      this.isUserAtBottom = (totalScrollableHeight - scrollTop) <= clientHeight;

      // 若用户滚动到接近底部（距离底部小于50px），则清空未读计数并隐藏提示
      if (totalScrollableHeight - scrollTop <= 50) {
        this.unreadCount = 0;
        this.showNewMsgTip = false;
      }

      // 情况1：滚动到顶部，处理临时数据
      if (scrollTop === 0 && this.tempChatList.length > 0) {
        this.appendTempData();
        return;
      }

      // 情况2：距离顶部 <= 1/3总高度，触发预加载（且不在加载中、有更多数据）
      if (
          totalScrollableHeight > 0 && // 避免容器高度为0的异常
          scrollTop <= totalScrollableHeight - 10 && // 核心：1/3高度触发
          !this.isLoadingMore &&
          !this.loadend &&
          !this.isPreloading
      ) {
        this.preloadData(); // 预加载数据到临时变量
      }
    },
    /**
     * 预加载数据：将请求到的数据存到临时变量，不直接显示
     */
    preloadData() {
      this.isPreloading = true; // 标记预加载中
      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$i18n('loading', '加载中...'),
      });

      let param = {
        liveId: this.live.id,
        pageNum: this.pageNo,
        pageSize: this.size,
      };

      this.$http
          .get("/chat/liveChatList", {params: param})
          .then((res) => {
            this.loadend = res.data.length < this.size; // 判断是否还有更多数据
            if (res.data.length > 0) {
              this.tempChatList.unshift(...res.data); // 存到临时变量（保持顺序）
              this.pageNo++; // 页码自增（下次预加载用）
            }
          })
          .catch((err) => {
            console.error("预加载失败：", err.message);
          })
          .finally(() => {
            toast.clear();
            this.isPreloading = false; // 结束预加载状态
          });
    },

    /**
     * 将临时数据追加到显示列表（滚动到顶部时触发）
     */
    appendTempData() {
      // 保存当前滚动位置（避免追加数据后滚动跳动）
      const scrollDiv = this.$refs.scrollDiv;
      const currentScrollTop = scrollDiv.scrollTop;
      const currentScrollHeight = scrollDiv.scrollHeight;

      // 将临时数据合并到正式列表
      this.chatList.unshift(...this.tempChatList);
      this.chatShowList = JSON.parse(JSON.stringify(this.chatList));

      // 清空临时变量
      this.tempChatList = [];

      // 修复滚动位置：保持相对滚动位置不变
      this.$nextTick(() => {
        const newScrollHeight = scrollDiv.scrollHeight;
        // 计算新的滚动位置（保证视觉上内容不跳动）
        scrollDiv.scrollTop = currentScrollTop + (newScrollHeight - currentScrollHeight);
      });
    },
    getInitialChatList() {
      let param = {
        liveId: this.live.id,
        pageNum: this.pageNo,
        pageSize: this.size,
      };

      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$i18n('loading', '加载中...'),
      });

      this.$http
          .get("/chat/liveChatList", {params: param})
          .then((res) => {
            this.loadend = res.data.length < this.size;
            this.chatList = res.data;
            this.chatShowList = JSON.parse(JSON.stringify(this.chatList));
            this.pageNo++;
            if (this.pageNo === 2) { // 首次加载后自动滚动到底部
              this.scrollToBottom();
            }
          })
          .catch((err) => {
            console.error("初始加载失败：", err.message);
          })
          .finally(() => {
            toast.clear();
          });
    },
    inputChat() {
      if (!this.chatContext) {
        this.$toast(this.$i18n('enterContent', '请输入内容！'));
        return;
      }
      let param = {
        chatContext: this.chatContext,
        liveId: this.live.id,
        nickname: this.userInfo.nickname,
        avatar: this.userInfo.avatar,
      };
      this.showInputTip = true;
      this.tipMsg = this.$i18n('messageSending', '消息发送...');
      this.chatContext = "";
      // 恢复样式
      this.showSendBt = false;
      this.$http
          .post("/chat/insertChat", param)
          .then(() => {
            this.tipMsg = "";
          })
          .catch((err) => {
            this.$toast.fail(err.message);
          })
          .finally(() => {
            this.showInputTip = false;
          });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: cover;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .block {
      width: 225px;
      height: 250px;
      background-image: url("~@/assets/images/redPacket/bg_pop.png");
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .title {
        font-size: 20px;
        color: #3e1e21;
      }

      .money {
        margin: 10px;
        color: #FF3333;
        font-weight: 500;
      }
    }
  }

  .chatContainer {
    //border: 1px solid #FF6B95;
    margin-top: 90px;
    width: 100vw;
    height: calc(100vh - 90px);
    margin-bottom: 65px;
    overflow-y: scroll;

    .chatScrollWrap {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-end;
      color: #fff;
      padding-bottom: 10px;

      .timeTip {
        font-size: 10px;
        color: #8a8886;
        //border: 1px solid #F34;
        margin-left: 70px;
        margin-bottom: 20px;
      }
    }
  }

  .newMsgTipWrap {
    position: fixed;
    right: 20px; /* 调整位置到右侧，避免遮挡输入框 */
    bottom: 120px;
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    font-size: 14px;
    color: #063058;
    cursor: pointer; /* 提示可点击 */
    z-index: 4; /* 确保在输入框上方 */

    img {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
  }

  .chatInputTip {
    position: fixed;
    bottom: 80px;
    right: 15%;
    font-size: 15px;
    color: #7a7a7a;
  }

  /* ═══════════════════════════════════════════
     输入栏：flex 布局重做
     - inputWrap 铺满、gap 统一间距
     - inputTxt flex:1 占满中间
     - sendBt 补全样式（此前完全没有）
     - wishBt 互斥显示 + nowrap + flex-shrink:0
     ═══════════════════════════════════════════ */
  .chatInputWrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #FFF;
    border-top: 1px solid #ddd;
    padding: 8px 12px;
    box-sizing: border-box;
    z-index: 3;

    .inputWrap {
      display: flex;
      align-items: center;
      width: 100%;
      gap: 8px;

      /* 输入框：占满中间所有剩余空间 */
      .inputTxt {
        flex: 1;
        min-width: 0;              /* 允许被压缩，不撑破容器 */
        border-radius: 16px;
        background-color: rgba(0, 0, 0, 0.06);
        padding: 4px 10px;
      }

      /* 发送按钮（原样式缺失，此处补全） */
      .sendBt {
        flex-shrink: 0;
        height: 34px;
        padding: 0 18px;
        border: none;
        border-radius: 17px;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 2px;
        color: #6b4413;
        background: linear-gradient(135deg, #f7e3b0 0%, #e8c26a 45%, #d4a94e 100%);
        box-shadow: 0 2px 8px rgba(212, 169, 78, 0.55),
        inset 0 1px 1px rgba(255, 255, 255, 0.7);
        cursor: pointer;
        transition: transform 0.15s ease;

        &:active { transform: scale(0.94); }
      }

      /* ═══ 婚礼风格「送祝福」按钮：香槟金渐变 + 流光 + 心跳 ═══ */
      .wishBt {
        flex-shrink: 0;            /* 不许被压缩 */
        white-space: nowrap;        /* 文字永不换行 */
        position: relative;
        height: 34px;
        padding: 0 14px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        border: none;
        border-radius: 17px;
        cursor: pointer;
        overflow: hidden;
        color: #6b4413;
        font-size: 13px;
        font-weight: bold;
        letter-spacing: 1px;
        background: linear-gradient(135deg, #f7e3b0 0%, #e8c26a 45%, #d4a94e 100%);
        box-shadow: 0 2px 8px rgba(212, 169, 78, 0.55),
        inset 0 1px 1px rgba(255, 255, 255, 0.7);
        transition: transform 0.15s ease, box-shadow 0.15s ease;

        .wishHeart {
          font-size: 13px;
          animation: wishHeartBeat 1.4s ease-in-out infinite;
        }

        .wishText {
          line-height: 34px;
        }

        /* 流光扫过 */
        .wishShine {
          position: absolute;
          top: 0;
          left: -60%;
          width: 40%;
          height: 100%;
          background: linear-gradient(
              100deg,
              transparent 0%,
              rgba(255, 255, 255, 0.65) 50%,
              transparent 100%
          );
          transform: skewX(-20deg);
          animation: wishShineSweep 2.8s ease-in-out infinite;
        }

        &:active {
          transform: scale(0.94);
          box-shadow: 0 1px 4px rgba(212, 169, 78, 0.5),
          inset 0 1px 1px rgba(255, 255, 255, 0.7);
        }

        /* 发送中：呼吸收窄 + 禁点 */
        &.sending {
          pointer-events: none;
          animation: wishSendingPulse 0.8s ease-in-out infinite;
          filter: saturate(0.8);
        }
      }

      /* 发送成功的爱心迸发粒子（挂在 body 上，需全局样式穿透） */
      :global(.wishBurstHeart) {
        position: fixed;
        z-index: 9999;
        font-size: 16px;
        pointer-events: none;
        animation: wishBurstFly 1.5s cubic-bezier(0.2, 0.6, 0.4, 1) forwards;
      }
    }
  }
}

.submitWrap {
  margin: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .tip {
    width: 100%;
    margin-bottom: 10px;
    padding-right: 30px;
    font-size: 12px;
    color: #888888;
    text-align: right;
  }
}

/* ═══ 送祝福按钮相关动画 ═══ */

/* 爱心心跳 */
@keyframes wishHeartBeat {
  0%, 100% { transform: scale(1); }
  30%      { transform: scale(1.25); }
  45%      { transform: scale(1); }
}

/* 流光扫过 */
@keyframes wishShineSweep {
  0%       { left: -60%; }
  55%, 100% { left: 130%; }
}

/* 发送中呼吸 */
@keyframes wishSendingPulse {
  0%, 100% { transform: scale(1); }
  50%      { transform: scale(0.96); }
}

/* 爱心迸发：向上飘散 + 旋转 + 淡出 */
@keyframes wishBurstFly {
  0% {
    opacity: 0;
    transform: translate(0, 0) rotate(0deg) scale(0.6);
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate(var(--dx), -140px) rotate(var(--rot)) scale(1.3);
  }
}

/* 保持原有动画和其他样式不变 */
@keyframes floatUp {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  100% {
    transform: translateY(-100vh) rotate(10deg);
  }
}

@keyframes floatAcross {
  0% {
    transform: translateX(-50px);
  }
  100% {
    transform: translateX(100vw);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes rainFall {
  0% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(100vh);
  }
}

@keyframes fireworkExplode {
  0% {
    transform: scale(0.1);
    opacity: 0;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}

@keyframes sparkFly {
  0% {
    transform: rotate(0) translateY(0);
    opacity: 1;
    width: 2px;
    height: 2px;
  }
  100% {
    transform: rotate(0) translateY(-25px);
    opacity: 0;
    width: 1px;
    height: 1px;
  }
}
</style>
